import {
  Component,
  OnInit,
  ViewChild,
  Input,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { FormControl, NgForm, NgModel } from '@angular/forms';
import { CarrierService } from '../../../home/services/carrier.service';
import { Carrier } from '../shared/carrier.model';
import { CpModule } from '../../../../../shared/objects/auth/cpModule';
import { Module } from '../../../../../shared/objects/auth/module';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ModuleService } from '../../shared/module.service';
import { FormInvalidatorService } from '../../../home/services/form-invalidator.service';
import { ModalService } from '../../../../../core/services/modal.service';
import { Constants } from '../../../../../shared/const/constants';
import { ConfirmationDialogService } from '../../../../../core/services/confirmation-dialog.service';
import { GenericConfirmationComponent } from '../../../home/components/generic-confirmation/generic-confirmation.component';
import { CommonUtils } from '../../../../../shared/utils/common.utils';
import { GlobalResponsivenessService } from '../../../../../core/services/global-responsiveness.service';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { FileService } from '../../../../../shared/services/file.service';
import { DocumentStatus } from '../../../../../shared/objects/enum/documentStatus';
import {
  CarrierCertificate,
  ICarrierCertificate,
} from '../../../../../shared/objects/carrier/carrierCertificate';
import { AddCarrierCertificationComponent } from '../../../../../shared/components/add-carrier-certification/add-carrier-certification.component';
import { find, map, take } from 'rxjs/operators';
import { FileInputComponent } from '../../../../../shared/components/file-input/file-input.component';
import { NotificationService } from '../../../../../core/services/notification.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { UserRole } from '../../../../../shared/objects/auth/userRole';
import { CertificatesHubService } from '../../../../../shared/services/certificates-hub.service';
import { CertificationType } from '../../../../../shared/objects/carrier/certificationType';
import { NotificationType } from '../../../../../shared/enums/notification-type';
import { MatTooltip as MatTooltip } from '@angular/material/tooltip';
import { ThemePalette } from '@angular/material/core';
import { EquipmentTypeEnum } from '../shared/equipment-type.enum';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { BreadcrumbService } from '../../../../../core/services/breadcrumb.service';
import { Observable, Subscription, timer } from 'rxjs';
import { PageInfo } from '../../../../../shared/objects/breadcrumb/page-info.model';
import { PageUpdate } from '../../../../../shared/objects/breadcrumb/page-update';
import { Location } from '@angular/common';
import { RouteAction } from '../../../order/shared/route-action.enum';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {
  MatAutocomplete as MatAutocomplete,
  MatAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger as MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { OrderService } from '../../../order/shared/order.service';
import { Country } from '../../../../../shared/objects/order/country';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';

@Component({
    selector: 'app-carrier-profile',
    templateUrl: './carrier-profile.component.html',
    styleUrls: ['./carrier-profile.component.css'],
    standalone: false
})
export class CarrierProfileComponent implements OnInit, OnDestroy {
  @ViewChild('carrierForm', { static: true }) form: NgForm;
  @ViewChild('Company') companyModel: NgModel;
  @ViewChild('VatNumber') vatNumberModel: NgModel;
  @ViewChild('ChamberOfCommerce') chamberModel: NgModel;
  @ViewChild('accordion') accordion: MatAccordion;

  carrierId;
  editAvailable: boolean;
  myProfile: boolean;
  carrier: Carrier;
  carrierModules: CpModule[];

  @ViewChild(FileInputComponent, { static: true })
  fileInputControl: FileInputComponent;

  color: ThemePalette = 'accent';
  model: Carrier = new Carrier();
  foodChecked = false;
  technicalChecked = false;
  availableModules: CpModule[] = [];
  module = Module;

  savedSuccessfully = false;
  selectedDocument: CarrierCertificate;
  docIndex: number;
  isMobile: boolean;
  isTablet: boolean;
  private nextNavigationRoute = '';
  isLandscapeTablet = false;
  isLandscapeMobile = false;
  currentUserRole = UserRole.Unknown;
  certificationTypes: CertificationType[];
  emailIsUsed: boolean;
  public originalEmail = '';
  private successMessage: string;
  private errorMessage: string;
  private subs: Subscription[] = [];
  vatHasInvalidCharacters: boolean = false;

  allCountriesControl: FormControl;

  filteredAllCountries: Observable<Country[]>;

  removeCountryControl: FormControl;
  removeCountrySearch = '';
  filteredSelectedCountries: Observable<Country[]>;
  @ViewChild('allAuto') allAuto: MatAutocomplete;
  @ViewChild('removeAuto') removeAuto: MatAutocomplete;

  get emailRegex(): string {
    return Constants.EMAIL_REGEX_MAX;
  }
  documentsDatasource = new MatTableDataSource<CarrierCertificate>();
  columnsToDisplay = [
    'status',
    'certificateType',
    'certificationName',
    'expireDate',
    'actions',
  ];

  DocumentStatus = DocumentStatus;
  carrierCertificateId = null;

  CommonUtils = CommonUtils;
  @HostListener('keydown.enter', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (this.allAuto.isOpen || this.removeAuto.isOpen) {
      return;
    }

    event.preventDefault();
  }

  get maxAllowedFileSize(): number {
    return Constants.MAX_ALLOWED_FILE_SIZE_MB;
  }
  validExtensions = Constants.VALID_TENDER_DOCUMENT_EXTENSTION;

  constructor(
    private carrierService: CarrierService,
    private formInvalidator: FormInvalidatorService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private moduleService: ModuleService,
    private modalService: ModalService,
    private confirmationService: ConfirmationDialogService,
    private cd: ChangeDetectorRef,
    private globalResponsive: GlobalResponsivenessService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private certificatesHub: CertificatesHubService,
    private location: Location,
    private orderService: OrderService,
  ) {
    var attributes = this.globalResponsive.getResolutionAttributes();
    this.isTablet = attributes.isTablet;
    this.isMobile = attributes.isMobile;
    this.isLandscapeTablet = attributes.isLandscapeTablet;
    this.isLandscapeMobile = attributes.isLandscapeMobile;
    this.certificatesHub.connectToHubWithAutoConnect();
    this.getAllCountries();
  }
  allCountries: Country[] = [];
  selectedCountries: Country[] = [];

  get isImpersonated() {
    return this.authService.isImpersonated();
  }

  get companyModelValid() {
    return !this.companyModel.dirty && this.companyModel.valid;
  }
  get vatModelValid() {
    return !this.vatNumberModel.dirty && this.vatNumberModel.valid;
  }
  get chamberModelValid() {
    return !this.vatNumberModel.dirty && this.vatNumberModel.valid;
  }

  ngOnDestroy(): void {
    this.certificatesHub.disconnectFromHub();
    this.subs.forEach(sub => sub.unsubscribe());
    const pageInfo: PageInfo = {
      id: null,
      viewId: null,
    };
    this.breadcrumbService.updatePageInfo(pageInfo);
  }
  ngOnInit(): void {
    const contextRole = this.authService.getUserRole();

    if (this.router.url.includes('admin')) {
      this.myProfile = false;
      this.editAvailable = true;
    } else {
      this.editAvailable = contextRole === UserRole.CarrierAdmin;
      this.myProfile = true;
    }

    this.carrierId = this.route.snapshot.paramMap.get('id');
    this.carrierCertificateId =
      this.route.snapshot.queryParamMap.get('certificateId');

    this.currentUserRole = this.authService.getUserRole();
    if (this.myProfile) {
      this.carrierService.getCertificateTypes().subscribe(types => {
        this.certificationTypes = types;
        this.carrierService.getCarrierCertificates().subscribe(response => {
          this.documentsDatasource.data = response;
          this.addMissingCertificates();
          if (this.carrierCertificateId) {
            this.subs.push(
              timer(500).subscribe(() => {
                const selectedRow = document.getElementById(
                  this.carrierCertificateId,
                );
                const selectedMatExpansion = document.getElementById(
                  this.carrierCertificateId + '-ex',
                );
                if (this.isMobile) {
                  selectedMatExpansion.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'end',
                  });
                } else if (selectedRow) {
                  selectedRow.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'end',
                  });
                }
              }),
            );
          }
        });
      });
    }
    if (this.myProfile) {
      this.carrierService.getCarrierProfile().subscribe(response => {
        this.updateCarrier(response);
      });
    } else {
      this.carrierService.getCarrier(this.carrierId).subscribe(response => {
        this.updateCarrier(response);
      });
    }

    this.globalResponsive.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
    this.globalResponsive.isTablet$.subscribe(isTablet => {
      this.isTablet = isTablet;
    });

    this.globalResponsive.isPortraitTablet$.subscribe(
      isPortrait => (this.isLandscapeTablet = !isPortrait),
    );
    this.globalResponsive.isLandscapeMobile$.subscribe(
      isLandscape => (this.isLandscapeMobile = isLandscape),
    );
    this.subs.push(
      this.breadcrumbService.pageChangeSubject$.subscribe(page => {
        if (page === null) {
          this.navigateBack();
        } else {
          this.routeTo(page);
        }
      }),
    );
    this.setupNotificationMessages();

    this.certificatesHub.certificateEmitter.subscribe(
      (certificate: ICarrierCertificate) => {
        const document = this.documentsDatasource.data.find(
          d => d.id == certificate?.id && certificate?.id !== 0,
        );
        if (document) {
          document.documentName = certificate.documentName;
          document.status = certificate.status;
          document.expirationDate = certificate.expirationDate;
        }
      },
    );

    this.initCountriesControls();
  }

  private updateCarrier(response: Carrier) {
    this.model = response;
    this.checkEquipmentType(this.model.equipmentType);
    this.originalEmail = response.email;
    this.setupAvailableModules(response.modules);

    this.selectedCountries = [
      ...this.sortAscendingCountries(response.countries),
    ];
    const selectedCountriesIds = this.selectedCountries.map(el => el.countryId);
    this.allCountries = this.allCountries.filter(
      el => !selectedCountriesIds.includes(el.countryId),
    );
    const pageInfo: PageInfo = {
      id: this.carrierId,
      viewId: this.model.company,
    };
    this.breadcrumbService.updatePageInfo(pageInfo);
    this.cd.markForCheck();
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.removeCountryControl.markAsDirty();
      this.allCountriesControl.markAsDirty();
    }
  }
  getAllCountries() {
    this.orderService.getCountries().then(value => {
      this.allCountries = this.sortAscendingCountries(value).filter(
        el => el.isPartner,
      );
    });
  }

  public sortAscendingCountries(countries: Country[]): Country[] {
    countries.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    );
    return countries;
  }

  get isCarrierAdmin() {
    return this.currentUserRole == UserRole.CarrierAdmin;
  }

  get displayCertificatesCards() {
    return this.isMobile;
  }

  public toggleTooltip(tooltip: MatTooltip): void {
    tooltip.toggle();
  }

  openCertificatePanel(panel: Element) {
    var element = document.getElementById(panel.id);
    this.scrollElementIntoView(element);
  }

  scrollElementIntoView(element) {
    setTimeout(() => {
      element.scrollIntoView({ block: 'nearest' });
    }, 250);
  }

  get displayExpiredCertificatesErrorMessage() {
    return (
      this.documentsDatasource.data.find(
        d => d.status == DocumentStatus.Expired,
      ) != null
    );
  }

  resolveMissingCertificate(type: any, typeName: any) {
    let carrierCertificate = new CarrierCertificate();
    carrierCertificate = {
      ...carrierCertificate,
      certificationId: type,
      documentType: type,
      documentTypeName: typeName,
      id: 0,
      status: DocumentStatus.Missing,
    };
    return carrierCertificate;
  }

  addMissingCertificates() {
    var certificates = this.documentsDatasource.data;
    this.certificationTypes.forEach(element => {
      if (certificates.findIndex(c => c.documentType == element.id) == -1)
        certificates.push(
          this.resolveMissingCertificate(element.id, element.name),
        );
    });
    this.documentsDatasource.data = certificates;
  }

  private initCountriesControls(): void {
    this.allCountriesControl = new FormControl();
    this.filteredAllCountries = this.allCountriesControl?.valueChanges.pipe(
      map(name => this._filterAll(name, this.allCountries)),
    );

    this.removeCountryControl = new FormControl();
    this.filteredSelectedCountries =
      this.removeCountryControl?.valueChanges.pipe(
        map(name => this._filterAll(name, this.selectedCountries)),
      );
  }

  resetAllCountriesControl(val: MatAutocompleteSelectedEvent): void {
    const selectedCountry = val.option.value;
    const filteredAllCountries = this.allCountries.filter(
      el => el.countryId != selectedCountry.countryId,
    );
    this.allCountries = [...filteredAllCountries];
    this.selectedCountries.push(selectedCountry);

    this.allCountriesControl.reset();
  }
  resetSelectedCountriesControl(val: MatAutocompleteSelectedEvent): void {
    const selectedCountry = val.option.value;
    const filteredSelectedCountries = this.selectedCountries.filter(
      el => el.countryId != selectedCountry.countryId,
    );
    this.selectedCountries = [...filteredSelectedCountries];
    this.allCountries.push(selectedCountry);

    this.removeCountryControl.reset();
  }

  displayFn(ct: string): string | undefined {
    return ct || undefined;
  }
  private _filterAll(
    searchedCountry: Country | string,
    countries: Country[],
  ): Country[] {
    if (!searchedCountry) {
      return countries;
    }
    if (typeof searchedCountry == 'object') {
      return countries.filter(el => el.countryId != searchedCountry.countryId);
    } else {
      const filtered = countries.filter(el => {
        return (
          el.name
            .toLocaleLowerCase()
            .includes((searchedCountry as string).toLocaleLowerCase()) ||
          el.code
            .toLocaleLowerCase()
            .includes((searchedCountry as string).toLocaleLowerCase())
        );
      });
      return filtered;
    }
  }

  public navigateBack() {
    if (this.isImpersonated) {
      this.location.back();
      return;
    }

    const generalInfoDirty =
      this.companyModel.dirty ||
      this.vatNumberModel.dirty ||
      this.chamberModel.dirty ||
      this.form.dirty;
    if (
      this.allCountriesControl.dirty ||
      this.removeCountryControl.dirty ||
      generalInfoDirty
    ) {
      this.showDirtyDataWarning(RouteAction.BACK);
    } else {
      this.location.back();
    }
  }
  public routeTo(update: PageUpdate): void {
    if (this.isImpersonated) {
      if (update.isLogout) {
        this.authService.logout();
      }
      this.router.navigate([update.route]);
      return;
    }
    const generalInfoDirty =
      this.companyModel.dirty ||
      this.vatNumberModel.dirty ||
      this.chamberModel.dirty ||
      this.form.dirty;
    if (
      this.allCountriesControl.dirty ||
      this.removeCountryControl.dirty ||
      generalInfoDirty
    ) {
      this.nextNavigationRoute = update.route;
      this.showDirtyDataWarning(RouteAction.MODULE);
    } else {
      if (update.isLogout) {
        this.authService.logout();
      }
      this.router.navigate([update.route]);
    }
  }
  private checkEquipmentType(equipmentType: number) {
    this.foodChecked =
      equipmentType === EquipmentTypeEnum.Food ||
      this.model.equipmentType === EquipmentTypeEnum.FoodAndTechnical;
    this.technicalChecked =
      equipmentType === EquipmentTypeEnum.Technical ||
      equipmentType === EquipmentTypeEnum.FoodAndTechnical;
  }

  clearEmailError(): void {
    this.emailIsUsed = false;
    this.form.control.get('email').setErrors({ emailInvalid: null });
    this.form.control.get('email').markAsPristine();
  }
  validateEmail(emailControl: any): void {
    const emailMask = new RegExp(Constants.EMAIL_REGEX_MAX);
    if (!this.model.email) {
      return;
    }
    this.carrierService
      .isCarrierEmailAlreadyUsed(this.model.email)
      .then(response => {
        this.emailIsUsed = response;
        const shouldVerifyEmail = this.originalEmail !== this.model.email;

        if (
          shouldVerifyEmail &&
          (this.emailIsUsed ||
            this.model.email === '' ||
            !emailMask.test(this.model.email))
        ) {
          emailControl.setErrors({ emailInvalid: true });
          emailControl.markAsTouched();
        } else {
          emailControl.setErrors(null);
          emailControl.markAsPristine();
        }
      });
  }

  validateVatNumber(): void {
    const vatPattern = /^[A-Z0-9\s]*$/;
    this.vatHasInvalidCharacters = !vatPattern.test(this.model.vatNumber || '');
  }

  onVatPaste(event: ClipboardEvent): void {
    setTimeout(() => {
      this.validateVatNumber();
    }, 0);
  }

  selectModule(module: CpModule): void {
    const selectedModule = this.availableModules.find(
      c => c.name === module.name,
    );

    selectedModule.available = !selectedModule.available;
  }

  view(document, fileName) {
    const fileExtension = !!fileName
      ? CommonUtils.getExtension(fileName)
      : '.file';
    this.carrierService.viewDocument(document, fileExtension);
  }

  browse(document: CarrierCertificate, index: number) {
    this.selectedDocument = document;
    this.docIndex = index;
    this.fileInputControl.selectFile();
  }

  upload(file: File): void {
    const modalRef = this.modalService.open(AddCarrierCertificationComponent, {
      centered: true,
      container: '#AppContent',
    });

    modalRef.componentInstance.expirationDate.pipe(take(1)).subscribe(date => {
      let documentToBeUploaded = this.selectedDocument;
      documentToBeUploaded = {
        ...documentToBeUploaded,
        documentName: !!file.name ? file.name : '',
        expirationDate: date,
      };

      this.carrierService.uploadDocument(documentToBeUploaded, file).subscribe(
        () => {
          this.notificationService.show(
            NotificationType.INFO,

            'SHARED.DOCUMENTS-UPLOAD-TEXT-SUCCESS',
            'SHARED.DOCUMENTS-UPLOAD-TITLE',
          );
          this.updateCertificate(this.docIndex);
        },
        error => {
          this.notificationService.show(
            NotificationType.ERROR,

            'SHARED.DOCUMENTS-UPLOAD-TEXT-ERROR',
            'SHARED.DOCUMENTS-UPLOAD-TITLE',
          );
        },
      );
    });

    modalRef.result.catch(() => {
      this.closeContextModal();
    });
  }

  reloadCertificates() {
    this.carrierService.getCarrierCertificates().subscribe(response => {
      this.documentsDatasource.data = response;
      this.addMissingCertificates();
    });
  }

  updateCertificate(id: number) {
    const contextCertificate = this.documentsDatasource.data[this.docIndex];
    this.carrierService.getCarrierCertificates().subscribe(response => {
      var index = response
        .map(c => c.documentType == contextCertificate?.documentType)
        .lastIndexOf(true);
      var updated = response[index];
      if (contextCertificate != null && updated != null) {
        contextCertificate.expirationDate = updated.expirationDate;
        contextCertificate.documentName = updated.documentName;
        contextCertificate.status = updated.status;
        contextCertificate.id = updated.id;
      }
      var expired = this.documentsDatasource.data.filter(
        d => d.status == DocumentStatus.Expired,
      ).length;
      this.certificatesHub.expiredCertificatesEmitter.next(expired);
    });
  }

  private closeContextModal(): void {
    this.modalService.close();
  }

  saveGeneralInformation(form: NgForm): void {
    this.formInvalidator.invalidate(this.form, ['website']);
    if (form.valid) {
      this.model.modules = !this.myProfile
        ? this.availableModules
            .filter(module => module.available === true)
            .map(module => Module[module.name])
        : [];

      const carrierEquipmentType =
        this.foodChecked && this.technicalChecked
          ? EquipmentTypeEnum.FoodAndTechnical
          : this.foodChecked
          ? EquipmentTypeEnum.Food
          : this.technicalChecked
          ? EquipmentTypeEnum.Technical
          : EquipmentTypeEnum.Unknown;

      this.model.equipmentType = carrierEquipmentType;
      this.carrierService.editCarrier(this.model, !this.myProfile).subscribe(
        () => {
          this.form.controls['website'].markAsPristine();
          this.form.form.markAsPristine();
          this.companyModel.control.markAsPristine();
          this.vatNumberModel.control.markAsPristine();
          this.chamberModel.control.markAsPristine();
          this.savedSuccessfully = true;
          this.toastrService.success(this.successMessage);
          this.cd.markForCheck();
        },
        error => {
          this.savedSuccessfully = false;
          this.toastrService.error(this.errorMessage);
        },
      );
    }
  }

  public saveCountries(form: NgForm) {
    this.model.countries = this.selectedCountries;
    this.carrierService.editCarrier(this.model, !this.myProfile).subscribe(
      () => {
        this.savedSuccessfully = true;
        this.toastrService.success(this.successMessage);
        this.allCountriesControl.markAsPristine();
        this.removeCountryControl.markAsPristine();
        this.cd.markForCheck();
      },
      error => {
        this.savedSuccessfully = false;
        this.toastrService.error(this.errorMessage);
      },
    );

    this.sortAscendingCountries(this.allCountries);
    this.sortAscendingCountries(this.selectedCountries);
  }
  private setupNotificationMessages(): void {
    this.translateService
      .get('CARRIER-PROFILE.EDIT-SUCCESS-TEXT')
      .subscribe(message => {
        this.successMessage = message;
      });
    this.translateService
      .get('CARRIER-PROFILE.EDIT-ERROR-TEXT')
      .subscribe(message => {
        this.errorMessage = message;
      });
  }

  private setupAvailableModules(modules: Module[]): void {
    this.moduleService.getFeatureDashboardModules(modules).forEach(cpModule => {
      this.availableModules.push(cpModule);
    });
  }

  showDirtyDataWarning(routeAction: RouteAction): void {
    const confirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' },
    );
    this.confirmationService.setup(confirmationModalRef, {
      bodyKey: 'ORDER-LIST-DETAILS.MESSAGE-CLOSE-MODAL',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      okButtonKey: 'SHARED.WARNING-CLOSE-YES',
      titleKey: 'ORDER-LIST-DETAILS.TITLE-CLOSE-MODAL',
      confirmAction: this.processDirtyEntityWarningOption.bind(
        this,
        routeAction,
      ),
      dismissAction: this.processDismissDirtyEntityWarning.bind(
        this,
        routeAction,
      ),
    });
  }

  private processDirtyEntityWarningOption(answer: RouteAction): void {
    this.modalService.dismissAll('close');
    if (answer === RouteAction.BACK) {
      this.location.back();
    }
    if (answer === RouteAction.MODULE) {
      if (this.nextNavigationRoute === '/login') {
        this.authService.logout();
      }
      this.router.navigate([this.nextNavigationRoute]);
      this.nextNavigationRoute = '';
    }
  }

  private processDismissDirtyEntityWarning(): void {
    this.modalService.closeAll();
  }

  formatText(data: string): string {
    if (this.isMobile) {
      if (this.isLandscapeMobile) {
        return CommonUtils.formatTextLandscapeMobile(data);
      }
      return CommonUtils.formatTextPortraitMobile(data);
    } else if (this.isTablet) {
      if (this.isLandscapeTablet) {
        return CommonUtils.formatTextLandscapeTablet(data);
      }
      return CommonUtils.formatTextPortraitTablet(data);
    } else {
      return CommonUtils.formatTextDesktop(data);
    }
  }
}
